
import { Link } from 'react-router-dom';

export default function Commitment() {
  const commitments = [
    {
      icon: 'ri-book-read-line',
      title: 'Confident reading',
      description: 'Building strong reading fluency through curated materials'
    },
    {
      icon: 'ri-text',
      title: 'Strong vocabulary',
      description: 'Systematic vocabulary expansion and synonym practice'
    },
    {
      icon: 'ri-edit-line',
      title: 'Clear writing',
      description: 'Mastering writing formats with clarity and confidence'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Respect, consistency, and focus',
      description: 'Cultivating discipline and healthy learning habits'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-['Yeseva_One',serif] text-3xl md:text-4xl lg:text-5xl text-[#153223] mb-4 md:mb-6">
            Our Commitment
          </h2>
          <p className="text-lg md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed px-4">
            At OHT Tuition Academy, every child grows step-by-step through:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-8 md:mb-12">
          {commitments.map((item, index) => (
            <div 
              key={index}
              className="bg-[#F5F1E8] border-2 border-[#153223]/10 text-center p-6 md:p-8 rounded-2xl hover:border-[#153223] hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#153223] rounded-full mx-auto mb-4 shadow-lg">
                <i className={`${item.icon} text-2xl md:text-3xl text-[#FFE66D]`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#153223] mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center bg-gradient-to-r from-[#153223] to-[#2d5a3f] rounded-2xl p-8 md:p-12 shadow-2xl">
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6 px-4">
            We shape learners who think clearly, read meaningfully, and express themselves confidently.
          </h3>
          <p className="text-base md:text-xl text-[#F5F1E8] mb-6 md:mb-8 max-w-2xl mx-auto px-4">
            Students attending classes are expected to be consistent in their attendance and practice to ensure real progress.
          </p>
          <Link 
            to="/level-test-registration"
            className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-6 md:px-10 py-3 md:py-5 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer inline-flex items-center gap-2 text-base md:text-lg"
          >
            <i className="ri-seedling-line text-xl md:text-2xl"></i>
            <span className="hidden sm:inline">Start Your Child's English Journey</span>
            <span className="sm:hidden">Start Journey</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
